export const videoData = [
  {
    title: "Namaste JS",
    author: "Akshay Saini",
    url: "https://youtube.com/playlist?list=PLlasXeu85E9cQ32gLCvAvr9vNaUccPVNP&si=bHMAy0dQuKfnoxCd",
  },
  {
    title: "Hoisting",
    author: "YouTube",
    url: "https://youtu.be/U68MgTliPb0?si=WkEKmy7Fa6MrXfvN",
  },
  {
    title: "JS Interview Playlist",
    author: "Rahul Mishra",
    url: "https://youtube.com/playlist?list=PLKhlp2qtUcSaCVJEt4ogEFs6I41pNnMU5&si=lkPfnMShOvyaPdyS",
  },
  {
    title: "Redux",
    author: "Rahul Mishra",
    url: "https://youtu.be/JBn3tMNjZpI?si=GKsHfXqmttF5Sp0U",
  },
  {
    title: "Eva Coder",
    author: "Lydia Hallie",
    url: "https://www.youtube.com/@theavocoder/featured",
  },
  {
    title: "Event Loop",
    author: "Rahul Mishra",
    url: "https://youtu.be/JdJIUoa9qJU?si=jciyNa11WugsiYiH",
  },
  {
    title: "Closures",
    author: "Rahul Mishra",
    url: "https://youtu.be/Q4M78MEllP8?si=WRllJSYzZ-AGhwyM",
  },
  {
    title: "This Keyword",
    author: "Rahul Mishra",
    url: "https://youtu.be/kvTzkt8BwGc?si=GA2p3-q4bA2DugJZ",
  },
  {
    title: "This in Arrow Function",
    author: "Rahul Mishra",
    url: "https://youtu.be/btcbDS871mU?si=VltXgF0kJRYTjZ3V",
  },
  {
    title: "ColorCode.io",
    author: "YouTube",
    url: "https://www.youtube.com/@ColorCode-io",
  },
  {
    title: "JS Interview Questions",
    author: "YouTube",
    url: "https://www.youtube.com/playlist?list=PLyuRouwmQCjlLW9NjqoBbf9eVaFX4F9UZ",
  },
  {
    title: "Object Oriented JS",
    author: "Net Ninja",
    url: "https://youtube.com/playlist?list=PL4cUxeGkcC9i5yvDkJgt60vNVWffpblB7&si=sSLmhNoaGsN6A19U",
  },
  {
    title: "Chakde Frontend Interview Season 1",
    author: "Chirag goel",
    url: "https://youtube.com/playlist?list=PL4CFloQ4GGWI15pvWkG8F5hM5iBX7ZM5U&si=MUT_tY2omFLTqeVa",
  },
  {
    title: "Choked Frontend Interview Season 2",
    author: "Chirag goel",
    url: "https://youtube.com/playlist?list=PL4CFloQ4GGWIXCJJHwT6FPb5yVZcybuQW&si=GVHx2VauVMzQbCzB",
  },
  {
    title: "JS Mock Interviews",
    author: "Tech sith",
    url: "https://youtube.com/playlist?list=PL7pEw9n3GkoVxJHpxClc-zPUKFRuY8XJ3&si=IvWLqMBNL9UDECRX",
  },
  {
    title: "CSS Positions",
    author: " Tech Sith",
    url: "https://youtu.be/-vo0HzNHL3U?si=I6Axeocsii0wrS71",
  },
  {
    title: "100 JS Concepts",
    author: "Fireship",
    url: "https://youtu.be/lkIFF4maKMU?si=Bw-vCDSPpgxPB9kz",
  },
  {
    title: "Code Step by Step",
    author: "YouTube",
    url: "https://youtu.be/riloPTtAuAM?si=zVCv51DUFByO3QXz",
  },
];